import { StatusMessage } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { Wrench } from 'lucide-react';

/**
 * Placeholder for a Provider Detail tab (CT-4186). Each tab story (CT-4179…4185)
 * replaces its route element with the real tab. Kept so the routed tab bar never
 * lands on a blank screen while the epic is in flight.
 */
const ProviderTabPlaceholder = ({ labelKey, ticket }) => {
  const { t } = useTranslation('admin-studio');
  return (
    <StatusMessage
      icon={Wrench}
      title={t(labelKey)}
      subtitle={t('integrations.provider.tabPlaceholder', { ticket })}
    />
  );
};

export default ProviderTabPlaceholder;
